import { render, staticRenderFns } from "./ProfilePopup.vue?vue&type=template&id=23b4a4b6&"
import script from "./ProfilePopup.vue?vue&type=script&lang=js&"
export * from "./ProfilePopup.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePopup.vue?vue&type=style&index=0&id=23b4a4b6&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports